import { CurrentProfile } from "@domain/currentProfile/currentProfile";

export type StepId = "phone" | "language" | "country" | "birthDate" | "gender" | "interests" | "follows" | "thanks";

const PROMPT_KEY = "jgl_asked_to_complete_profile";

export function hasAskedToCompleteProfile(): boolean {
	try {
		return JSON.parse(localStorage.getItem(PROMPT_KEY) ?? "false") === true;
	} catch {
		return false;
	}
}

export function markAskedToCompleteProfile(): void {
	try {
		localStorage.setItem(PROMPT_KEY, JSON.stringify(true));
	} catch {
		// Storage unavailable.
	}
}

export function clearAskedToCompleteProfile(): void {
	try {
		localStorage.removeItem(PROMPT_KEY);
	} catch {
		// Storage unavailable.
	}
}

export type DataStepId = Exclude<StepId, "thanks">;

const DATA_STEPS: DataStepId[] = ["phone", "language", "country", "birthDate", "gender", "interests", "follows"];

export function showsCompleteProfileThanks(
	steps: DataStepId[],
	completed: { has(step: DataStepId): boolean }
): boolean {
	return steps.length > 0 && steps.every((step) => completed.has(step));
}

function isDataStepMissing(profile: CurrentProfile, step: DataStepId): boolean {
	if (step === "phone") {
		return !profile.phoneNumber && !profile.phoneNumberAuth;
	}
	if (step === "language") {
		return !profile.language;
	}
	if (step === "country") {
		return !profile.countryCode;
	}
	if (step === "birthDate") {
		return !profile.birthDate;
	}
	if (step === "gender") {
		return !profile.gender && !profile.customData?.askedGender;
	}
	if (step === "interests") {
		return profile.categories.length === 0;
	}
	return !profile.followeeCount;
}

export function missingCompleteProfileSteps(profile: CurrentProfile): DataStepId[] {
	return DATA_STEPS.filter((step) => isDataStepMissing(profile, step));
}

export function completeProfileProgress(profile: CurrentProfile): number {
	return (DATA_STEPS.length - missingCompleteProfileSteps(profile).length) / DATA_STEPS.length;
}
